import { axiosAuth } from './axiosInstances'

// KHAN-234: REST/Django naming standardization. El backend paso de
// userroles/{insertUserRoles,listedStudents}/ (verbos en el path) a un unico
// recurso REST user-roles/ con metodo HTTP + el filtro ?role=. Se preservan
// los nombres de las funciones exportadas y la forma de la respuesta de
// listedStudents (lista de usuarios con userid/name/lastname) para no tocar a
// los consumidores.
export async function new_userrole(iduser,idrole) {
    return axiosAuth().post('/user-roles/',{
        iduser:iduser,
        idrole:idrole
    })
}

export async function listedStudents() {
    return axiosAuth().get('/user-roles/', { params: { role: 'student' } })
  }
